import {
  CaretRight,
  Flag,
  Bank,
  ChartPie,
  Receipt,
  TrendUp,
} from '@phosphor-icons/react';

import { BottomSheet, BottomSheetContent } from '../common/BottomSheet';
import { useExpenseSheet } from '../../features/expenses/SheetProvider';
import { useIncomeSheet } from '../../features/income/SheetProvider';
import {
  useAssetSheet,
  useCategorySheet,
  useGoalSheet,
} from '../../features/quickCreate/SheetProviders';
import pt from '../../locales/pt';

/** Cada acção tem o seu ícone identificador com a cor de grupo do .pen. */
const ACTIONS = [
  {
    id: 'expense',
    titleKey: 'quickActionsExpense',
    hintKey: 'quickActionsExpenseHint',
    icon: Receipt,
    iconClass: 'text-group-needs',
  },
  {
    id: 'income',
    titleKey: 'quickActionsIncome',
    hintKey: 'quickActionsIncomeHint',
    icon: TrendUp,
    iconClass: 'text-group-savings',
  },
  {
    id: 'category',
    titleKey: 'quickActionsCategory',
    hintKey: 'quickActionsCategoryHint',
    icon: ChartPie,
    iconClass: 'text-group-wants',
  },
  {
    id: 'asset',
    titleKey: 'quickActionsAsset',
    hintKey: 'quickActionsAssetHint',
    icon: Bank,
    iconClass: 'text-group-custom-2',
  },
  {
    id: 'goal',
    titleKey: 'quickActionsGoal',
    hintKey: 'quickActionsGoalHint',
    icon: Flag,
    iconClass: 'text-sage-500',
  },
];

/**
 * Folha de criação rápida — corpo de `ds/overlay/bottom-sheet--mobile`:
 * lista de `ds/overlay/sheet-item--default` (superfície muted, radius
 * $radius-ds-md, ícone em cartão 38×38, título $type-body 600 + subtítulo
 * $type-chip) com gap $space-3.
 */
export function QuickActionsSheet({ open, onOpenChange }) {
  const { open: openExpense } = useExpenseSheet();
  const { open: openIncome } = useIncomeSheet();
  const { open: openCategory } = useCategorySheet();
  const { open: openAsset } = useAssetSheet();
  const { open: openGoal } = useGoalSheet();

  const handlers = {
    expense: () => openExpense(),
    income: () => openIncome(),
    category: () => openCategory(),
    asset: () => openAsset(),
    goal: () => openGoal(),
  };

  const handleSelect = (id) => {
    onOpenChange(false);
    handlers[id]?.();
  };

  return (
    <BottomSheet open={open} onOpenChange={onOpenChange}>
      <BottomSheetContent title={pt.nav.quickActionsTitle} layout="bottom">
        <ul className="flex flex-col gap-space-3">
          {ACTIONS.map((action) => {
            const Icon = action.icon;
            return (
              <li key={action.id}>
                <button
                  type="button"
                  onClick={() => handleSelect(action.id)}
                  className="flex w-full items-center gap-space-3 rounded-ds-md bg-muted p-space-3 text-left transition-colors hover:bg-muted/70"
                >
                  <span className="flex h-[38px] w-[38px] shrink-0 items-center justify-center rounded-ds-md bg-card">
                    <Icon
                      className={`h-[19px] w-[19px] ${action.iconClass}`}
                      aria-hidden
                    />
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="block text-type-body font-semibold text-foreground">
                      {pt.nav[action.titleKey]}
                    </span>
                    <span className="block text-type-chip font-normal text-muted-foreground">
                      {pt.nav[action.hintKey]}
                    </span>
                  </span>
                  <CaretRight
                    className="h-[15px] w-[15px] shrink-0 text-muted-foreground"
                    aria-hidden
                  />
                </button>
              </li>
            );
          })}
        </ul>
      </BottomSheetContent>
    </BottomSheet>
  );
}
